export enum STATUSES {
  SUCCESS = 'SUCCESS',
  REVOKED = 'REVOKED',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  RETRY = 'RETRY',
}
